import React from "react";
import GoalSummary from "./GoalSummary";
import { Goal } from "@/types/goals";
import AddGoalForm from "@/components/Common/Forms/AddGoalForm";

interface BeneficiaryGoalProps {
  beneficiary: Goal;
  onChange: (
    beneficiaryId: number | string,
    field: string,
    value: string | number | boolean,
  ) => void;
  isLast: boolean;
  isUserEnrolled?: boolean;
}

const BeneficiaryGoal: React.FC<BeneficiaryGoalProps> = ({
  beneficiary,
  onChange,
  isLast,
  isUserEnrolled,
}) => {
  return (
    <div>
      <div
        className={`${
          isUserEnrolled ? "pb-[32px]" : "px-[16px] py-[32px] md:p-[32px]"
        } `}
      >
        <AddGoalForm
          values={beneficiary}
          onChange={(field, value) =>
            onChange(beneficiary.beneficiaryId, field, value)
          }
        />

        <GoalSummary
          purpose={beneficiary.purpose}
          year={beneficiary.year}
          projectedAmount={beneficiary.projectedAmount}
          monthlyContribution={beneficiary.monthlyContribution}
        />
      </div>

      {!isLast && <hr />}
    </div>
  );
};

export default BeneficiaryGoal;
